var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"current-page":_vm.page,"loading":_vm.loading,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total},on:{"onAdd":_vm.handleAdd,"onChangePage":_vm.handleCurrentChange,"onHandle":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }